import { j as r } from "./jsx-runtime-944c88e2.js";
import { forwardRef as e } from "react";
import { y as s } from "./index-b1011fa6.js";
import { w as c, a as f } from "./filter-data-d3e34102.js";
import { c as h, L as j, I as F, H as u } from "./form-2514c6d8.js";
import { w } from "./form-field-wrapper.hoc-d784197f.js";
import "./index-efd35e77.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
import "./FloatingLabel-922c628f.js";
import "./index-93802845.js";
import "./package-metadata-3dcf116a.js";
import "./index.es-6889c727.js";
import "./Popup-b6c9078b.js";
import "./index-a0534bb4.js";
import "./Label-079ad7bc.js";
import "./Button-4c83e316.js";
import "./package-metadata-9ad1330d.js";
import "./theme-b013fa81.js";
import "./ButtonGroup-a9850ef0.js";
import "./surface-71c0d1c6.js";
import "./Dialog-a72b336a.js";
import "./Chip-cb37946d.js";
import "./keys-2b65407d.js";
import "./TreeView-aa1ef3e3.js";
import "./Reveal-e2f427f6.js";
import "./Animation-d8a017b3.js";
import "./TransitionGroup-34043d49.js";
import "./ActionSheet-b5bf2237.js";
import "./Animation-154b683d.js";
import "./noop-d627517c.js";
import "./package-metadata-a152adb8.js";
import "./FormElement-65f04cfd.js";
const m = e(function(o, i) {
  return o.filterable ? /* @__PURE__ */ r.jsx(C, { ...o, ref: i }) : /* @__PURE__ */ r.jsx(s, { ...o, ref: i });
});
m.displayName = "ComboBox";
const mr = w(m), pr = e(function({
  validationMessage: o,
  touched: i,
  modified: b,
  visited: B,
  label: n,
  hint: l,
  fieldWrapperClassName: d,
  ...t
}, x) {
  const p = i && o;
  return /* @__PURE__ */ r.jsxs(h, { className: d, children: [
    /* @__PURE__ */ r.jsxs(j, { editorId: t.id, editorValid: t.valid, children: [
      n,
      " ",
      t.required && /* @__PURE__ */ r.jsx("span", { className: "error-color", children: " *" })
    ] }),
    /* @__PURE__ */ r.jsx(m, { ...t, ref: x }),
    p && /* @__PURE__ */ r.jsx(F, { children: o }),
    !p && /* @__PURE__ */ r.jsx(u, { children: l })
  ] });
}), C = c(f(s));
export {
  m as ComboBox,
  mr as ComboBoxFormField,
  pr as FormElementComboBox
};
